export const environment = {
  production: false,
  streamPlay: {
    production: false,
  },
  wordpress: {
    baseUrl: 'https://wp-stagingcebl.streamamg.com',
  },
  cloudPay: 'https://staging-ceblpayments.streamamg.com',
  cebl: {
    endpoint: 'https://genius-sports-staging-api.streamamg.com/v1/basketball',
    key: null,
  },
};
